/* eslint-disable import/prefer-default-export */

import { AssetTypes } from '~generated/types'
import BriefcaseIcon from '~shared/icons/16/briefcase.svg'
import CopyIcon from '~shared/icons/16/copy.svg'
import PictureIcon from '~shared/icons/16/picture.svg'

export type AssetTypeOption = {
  value: AssetTypes
  label: string
  getIcon: () => React.ReactNode | null
}

export const assetTypeOptions: AssetTypeOption[] = [
  {
    value: AssetTypes.COPY,
    label: 'Copy',
    getIcon: () => <CopyIcon />,
  },
  {
    value: AssetTypes.ASSETS,
    label: 'Assets',
    getIcon: () => <PictureIcon />,
  },
  {
    value: AssetTypes.SALES_ENABLEMENT,
    label: 'Sales Enablement',
    getIcon: () => <BriefcaseIcon />,
  },
]
